/**
 * Check whether code is executed on serve or on browser
 */
var isServer = function isServer() {
  return !(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
};
export default isServer;